import { faEllipsis } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { t } from "i18next";
import React, { use, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";

import usePrivileges from "../../../../Auth/usePrivileges";
import { LotDetailContext } from "../../../../Contexts/LotDetailContext";
import EditLotBuildTimeDialog from "../../../../Dialogs/EditLotBuildTimeDialog";
import { useDateUtils } from "../../../../Utilities/useDateUtils";
import { LotStatus } from "../../../../Types/Lot";

export function LotTimingFields() {
    const {
        lotDetail: {
            summary: {
                businessUnitCode,
                buildStartUtc,
                buildEndUtc,
                currentStatus
            }
        },
        lotFlags: {
            canEditLotBuildTime
        }
    } = use(LotDetailContext);

    const { convertUTCToShortDateTime } = useDateUtils();
    const { admin, canGrade } = usePrivileges(businessUnitCode);
    const [showEditLotBuildTimeDialog, setShowEditLotBuildTimeDialog] = useState(false);

    return (
        <>
            <Form.Group as={Col} sm={6} controlId="formBuildStart">
                <Row>
                    <Form.Label column sm={4}>{`${t('LotDetails.Summary.BuildStart')}:`}</Form.Label>
                    <Col sm={8}>
                        <div className="d-flex justify-content-start">
                            <Form.Control type="text" disabled value={buildStartUtc ? convertUTCToShortDateTime(buildStartUtc) : ""} />
                            {currentStatus !== LotStatus.Graded &&
                                <Button variant="light" hidden={(!admin && !canGrade) || !canEditLotBuildTime} className="ms-2" onClick={() => setShowEditLotBuildTimeDialog(true)} >
                                    <FontAwesomeIcon icon={faEllipsis} />
                                </Button>
                            }
                        </div>

                    </Col>
                </Row>
            </Form.Group>
            <Form.Group as={Col} sm={6} controlId="formBuildEnd">
                <Row>
                    <Form.Label column sm={4}>{`${t('LotDetails.Summary.BuildEnd')}:`}</Form.Label>
                    <Col sm={8}>
                        <div className="d-flex justify-content-start">
                            <Form.Control type="text" disabled value={buildEndUtc ? convertUTCToShortDateTime(buildEndUtc) : ""} />
                            {currentStatus !== LotStatus.Graded &&
                                <Button variant="light" hidden={(!admin && !canGrade) || !canEditLotBuildTime} className="ms-2" onClick={() => setShowEditLotBuildTimeDialog(true)} >
                                    <FontAwesomeIcon icon={faEllipsis} />
                                </Button>
                            }
                        </div>
                    </Col>
                </Row>
            </Form.Group>
            <EditLotBuildTimeDialog showDialog={showEditLotBuildTimeDialog} closeDialog={() => setShowEditLotBuildTimeDialog(false)} />
        </>
    );
}